module.exports = __webpack_public_path__ + "img/verified.19183630.svg";